import { createFileRoute } from "@tanstack/react-router";
import AppCard from "@components/AppCard.tsx";
import FlagsDataGrid from "@components/flags/FlagsDataGrid.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute("/_dashboard/preferences/flags")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
  component: FlagsPage,
});

function FlagsPage() {
  return (
    <AppCard title="Tags">
      <FlagsDataGrid />
    </AppCard>
  );
}
